export default {"src":"/_next/static/media/dv_icon.a1861e1b.svg","height":13,"width":9,"blurWidth":0,"blurHeight":0};